
import { useEffect, useState } from "react";

import { Badge, Box, Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import { AiOutlineOrderedList, AiOutlineFileText, AiOutlineFileProtect } from "react-icons/ai";

import moment from "moment";
import "moment/locale/es-mx";

import { usePages } from "../../../hooks/usePages";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";

import { Layout } from "../../../components/Layout"

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { BuscarListadoEnvio } from "../../../connections/notificaciones/ListadoEnvioConnection";

import { ListadoEnvioNotificacionProps, ListadoEnvioProps } from "../../../interfaces/notificaciones/ListadoEnvioInterface";

export const ConsultarListadoEnvioPage = () => {

    const [loading, setLoading] = useState( false );

    const [rows, setRows] = useState<ListadoEnvioProps[]>( [] );
    const [recordsCount, setRecordsCount] = useState( 0 );

    const [openNotificaciones, setOpenNotificaciones] = useState( false );
    const [notificaciones, setNotificaciones] = useState<ListadoEnvioNotificacionProps[]>( [] );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [fechaInicio, setFechaInicio] = useState<moment.Moment | null>( moment() );
    const [fechaFin, setFechaFin] = useState<moment.Moment | null>( moment() );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(10);
    const { page: pageNotificaciones, rowsPerPage: rowsPerPageNotificaciones, handleChangePage: handleChangePageNotificaciones, handleChangeRowsPerPage: handleChangeRowsPerPageotificaciones } = usePages(5);

    const handleBuscar = () => {

        setFiltroAplicado( true );
        resetPage();

    };

    const handleLimpiar = () => {

        setFiltroAplicado( false );
        setFechaInicio( moment() );
        setFechaFin( moment() );

        setRows( [] );
        setRecordsCount( 0 );
        resetPage();

    };

    useEffect(() => {

        if ( !filtroAplicado || !fechaInicio || !fechaFin ) return;

        setLoading( true );
        setRows( [] );

        BuscarListadoEnvio({ fechaInicio: fechaInicio.format('YYYY-MM-DD'), fechaFin: fechaFin.format('YYYY-MM-DD'), page, rowsPerPage }).then( resp => {

            setTimeout(() => {

                setRows( resp.listadosEnvio );
                setRecordsCount( resp.recordsCount );
                setLoading( false );

            }, 700);

        });

    }, [ filtroAplicado, page, rowsPerPage, fechaInicio, fechaFin ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Listado de envío' }, { text: 'Consultar listado de envío' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de inicio"
                                            sx={{ width: '100%' }}
                                            value={ fechaInicio }
                                            onChange={ (v) => setFechaInicio(v) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de finalización"
                                            sx={{ width: '100%' }}
                                            value={ fechaFin }
                                            onChange={ (v) => setFechaFin(v) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 2 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'inherit' : 'primary' }
                                        variant='contained'
                                        disabled={ loading || !fechaInicio || !fechaFin }
                                        onClick={ filtroAplicado ? handleLimpiar : handleBuscar }
                                    >
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Usuario generó</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Ver notificaciones</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Ver listado de envío</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Ver remesa</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                            {
                                rows.map( ( { idListadoEnvio, fechaGeneracion, usuarioEnvia, notificaciones, documento, documentoRemesa, fechaRemesa }, index ) => (

                                    <TableRow key={ index } >

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography variant="h6" fontWeight={ 'bold' }>
                                                { 'GLEN-' + idListadoEnvio }
                                            </Typography>
                                        </TableCell>

                                        <TableCell>

                                            <Typography variant='subtitle1'>
                                                { moment( fechaGeneracion ).format('DD-MM-YYYY') }
                                            </Typography>

                                            <Typography variant='caption' color='text.secondary'>
                                                { moment( fechaGeneracion ).format('hh:mm a') }
                                            </Typography>

                                        </TableCell>

                                        <TableCell>
                                            { usuarioEnvia }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>

                                            <Tooltip title='Visualizar notificaciones'>

                                                <IconButton color="primary" onClick={ () => { setNotificaciones( notificaciones ); setOpenNotificaciones( true ); }}>

                                                    <Badge
                                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                        badgeContent={ <Typography variant="subtitle2">{ notificaciones.length }</Typography> }
                                                        color="secondary"
                                                    >
                                                        <AiOutlineOrderedList fontSize={ 28 } />
                                                    </Badge>

                                                </IconButton>

                                            </Tooltip>

                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>

                                            <Tooltip title='Visualizar listado de envío'>

                                                <IconButton color="primary" onClick={ () => { setDocumento( documento ); setOpenDocumento( true ); }}>
                                                    <AiOutlineFileText fontSize={ 28 } />
                                                </IconButton>

                                            </Tooltip>

                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>

                                            {
                                                documentoRemesa
                                                &&
                                                    <Tooltip title='Visualizar documento de remesa'>

                                                        <IconButton color="primary" onClick={ () => { setDocumento( documentoRemesa ); setOpenDocumento( true ); }}>
                                                            <AiOutlineFileText fontSize={ 28 } />
                                                        </IconButton>

                                                    </Tooltip>
                                            }

                                            {
                                                fechaRemesa
                                                &&
                                                    <>

                                                        <Typography variant='subtitle1'>
                                                            { moment( fechaRemesa ).format('DD-MM-YYYY') }
                                                        </Typography>

                                                        <Typography variant='caption' color='text.secondary'>
                                                            { moment( fechaRemesa ).format('hh:mm a') }
                                                        </Typography>

                                                    </>
                                            }

                                        </TableCell>

                                    </TableRow>

                                ))
                            }

                            {
                                    ( recordsCount === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={ 7 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>

                                                <TableCell colSpan={ 7 } align='center'>

                                                    <CircularProgress size={ 26 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordsCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                        colSpan={ 8 }
                                        count={ recordsCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage={ 'Filas por página:' }
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

            <Dialog
                maxWidth="xl"
                fullWidth={ true }
                open={ openNotificaciones }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Notificación(es)
                </DialogTitle>

                <DialogContent>

                    <Grid container spacing={ 3 }>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TableContainer sx={{ borderRadius: 3 }}>

                                <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Referencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Persona y domicilio a notificar</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Tipo de notificación</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Documento a notificar</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                    {
                                        (   rowsPerPageNotificaciones > 0
                                            ? notificaciones.slice(pageNotificaciones * rowsPerPageNotificaciones, pageNotificaciones * rowsPerPageNotificaciones + rowsPerPageNotificaciones)
                                            : notificaciones
                                        ).map( ( { fechaNotificacion, referencia, otraReferencia, personaNotificar, tipoParte, domicilio, tipoNotificacion, tipoAcuerdo, subTipoAcuerdo, acuerdo, cedulaNotificacion, aceptada, motivoNoAceptada }, index ) => (

                                            <TableRow key={ index } >

                                                <TableCell>

                                                    <Typography variant='subtitle1'>
                                                        { moment( fechaNotificacion ).format( 'DD-MM-YYYY' ) }
                                                    </Typography>

                                                    <Typography variant='caption' color='text.secondary'>
                                                        { moment( fechaNotificacion ).format( 'hh:mm a' ) }
                                                    </Typography>

                                                </TableCell>

                                                <TableCell>

                                                    <Typography variant="subtitle1">
                                                        <strong>{ referencia }</strong>
                                                    </Typography>

                                                    { otraReferencia && <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>F. { otraReferencia }</Typography> }

                                                </TableCell>

                                                <TableCell>

                                                    <Typography variant="subtitle1">
                                                        <strong>{ personaNotificar.toUpperCase() }</strong> ({ tipoParte })
                                                    </Typography>
                                                    <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 12 }>{ domicilio }</Typography>

                                                </TableCell>

                                                <TableCell> { tipoNotificacion } </TableCell>

                                                <TableCell>
                                                    {
                                                        subTipoAcuerdo
                                                        ?
                                                            <>
                                                                <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                                <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>({ subTipoAcuerdo })</Typography>
                                                            </>
                                                        :
                                                            <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                    }
                                                </TableCell>

                                                <TableCell>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>

                                                        <Tooltip title='Visualizar documento a notificar'>

                                                            <IconButton color="primary" onClick={ () => { setDocumento( acuerdo ); setOpenDocumento( true ); }}>
                                                                <AiOutlineFileText fontSize={ 28 } />
                                                            </IconButton>

                                                        </Tooltip>

                                                        <Tooltip title='Visualizar cédula de notificación'>

                                                            <IconButton color="primary" onClick={ () => { setDocumento( cedulaNotificacion ); setOpenDocumento( true ); }}>
                                                                <AiOutlineFileProtect fontSize={ 28 } />
                                                            </IconButton>

                                                        </Tooltip>

                                                        <Tooltip title={ motivoNoAceptada ?? '' }>

                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    backgroundColor: aceptada ? '#e8f5e9' : '#fdecea',
                                                                    color: aceptada ? '#2e7d32' : '#cd1706',
                                                                    borderRadius: '50%',
                                                                    width: 36,
                                                                    height: 36,
                                                                }}
                                                            >
                                                                { aceptada ? <CheckCircleIcon sx={{ fontSize: 20 }} /> : <CancelIcon sx={{ fontSize: 20 }} /> }
                                                            </Box>

                                                        </Tooltip>

                                                    </Box>

                                                </TableCell>

                                            </TableRow>

                                        ))
                                    }

                                    {
                                        notificaciones.length === 0
                                        &&
                                            <TableRow>
                                                <TableCell
                                                    colSpan={ 8 }
                                                    align="center"
                                                >
                                                    <Typography variant="caption" color='secondary'> No se encontraron registros </Typography>
                                                </TableCell>
                                            </TableRow>
                                    }

                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>

                                            <TableCell colSpan={ 2 }>
                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { notificaciones.length } </Typography>
                                            </TableCell>

                                            <TablePagination
                                                rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                                colSpan={ 8 }
                                                count={ notificaciones.length }
                                                rowsPerPage={ rowsPerPageNotificaciones }
                                                page={ pageNotificaciones }
                                                onPageChange={ handleChangePageNotificaciones }
                                                onRowsPerPageChange={ handleChangeRowsPerPageotificaciones }
                                                ActionsComponent={ TablePaginationActions }
                                                labelRowsPerPage={ 'Filas por página:' }
                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                    return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' onClick={ () => setOpenNotificaciones( false ) }>Cerrar</Button>
                </DialogActions>

            </Dialog>

        </Layout>
    )
}
